module.exports = __webpack_public_path__ + "media/award-android-195a5325.png";